const LEADERBOARD_CONFIG = {
  'play-2-mint': {
    title: 'Play2Mint Leaderboard',
    subTitle: `Mauris vel odio placerat, posuere velit id, porta nulla. Nunc \
      placerat eros at cursus ultrices. Maecenas sagittis lacus ac \
      turpis sollicitudin consequat. Aenean euismod ullamcorper \
      tellus, consectetur sagittis purus sollicitudin vel. Aenean \
      imperdiet, neque quis porttitor tristique, elit nisl rutrum \
      velit, vitae auctor libero mi et quam.`,
    hideBreakerStatus: true,
  },
  'the-big-break': {
    title: 'The Big Break Leaderboard',
    subTitle: `Mauris vel odio placerat, posuere velit id, porta nulla. Nunc \
      placerat eros at cursus ultrices. Maecenas sagittis lacus ac \
      turpis sollicitudin consequat. Aenean euismod ullamcorper \
      tellus, consectetur sagittis purus sollicitudin vel. Aenean \
      imperdiet, neque quis porttitor tristique, elit nisl rutrum \
      velit, vitae auctor libero mi et quam.`,
  },
  'the-big-break-top-scores': {
    title: 'The Big Break Leaderboard',
    subTitle: `Mauris vel odio placerat, posuere velit id, porta nulla. Nunc \
      placerat eros at cursus ultrices. Maecenas sagittis lacus ac \
      turpis sollicitudin consequat. Aenean euismod ullamcorper \
      tellus, consectetur sagittis purus sollicitudin vel. Aenean \
      imperdiet, neque quis porttitor tristique, elit nisl rutrum \
      velit, vitae auctor libero mi et quam.`,
  },
} as const;

export type Leaderboard = keyof typeof LEADERBOARD_CONFIG;

export const isLeaderboard = (type: string): type is Leaderboard => {
  return Object.keys(LEADERBOARD_CONFIG).includes(type as Leaderboard);
};

export const getLeaderboardConfig = (type: Leaderboard) => {
  return LEADERBOARD_CONFIG[type];
};

export type LeaderboardEntry = {
  displayname: string;
  rank: number;
  score: number;
  isBreaker?: boolean;
};
